/**
 * Normalize HR API base so callers can use `${API_URL}/hr/...` and `${API_URL}/get-column/...`.
 * Accepts either `http://host:5002` or `http://host:5002/api`.
 */
function resolveApiUrl() {
  const raw = (process.env.REACT_APP_API_URL || "http://localhost:5002").trim();
  if (!raw) return "http://localhost:5002/api";
  const base = raw.replace(/\/+$/, "");
  return /\/api$/i.test(base) ? base : `${base}/api`;
}

const API_URL = resolveApiUrl();

export { API_URL, resolveApiUrl };
export default API_URL;
